import { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import styles from '../../ApplicationForm.module.scss';

/**
 * Server-side Error-watching component for Epic/EpicCare stylized to work with Custom App Request Form
 * @param {Object} props properties
 * @returns Custom input
 */
const AlertMonitor = props => {
	const [display, setDisplay] = useState({});
	useEffect(() => {
		if (props.formik?.status?.error) {
			setDisplay(props.formik.status.error);
		} else {
			setDisplay(null);
		}
	}, [props.formik?.status]);

	return display ? (
		<Box className={styles['sticky']} sx={{ width: '100%' }}>
			<Alert
				severity={display.severity ?? 'warning'}
				onClose={() => {
					setDisplay(null);
				}}
			>
				<AlertTitle>{display.cause ?? 'Warning'}</AlertTitle>
				{display.message ?? 'Unknown error occurred'}
			</Alert>
		</Box>
	) : null;
};

export default AlertMonitor;
